@file:OptIn(InternalResourceApi::class)

package loco

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/loco/"

@delegate:ResourceContentHash(491_644_770)
public val Res.string.ME_WEIGHT_LOSS_PROGRESS_SECTION: StringResource by lazy {
      StringResource("string:ME_WEIGHT_LOSS_PROGRESS_SECTION", "ME_WEIGHT_LOSS_PROGRESS_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12900, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12932, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13352, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11688, 67),
      ))
    }

@delegate:ResourceContentHash(-1_866_679_093)
public val Res.string.ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT: StringResource by lazy {
      StringResource("string:ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT", "ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12984, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13012, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13428, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11756, 56),
      ))
    }

@delegate:ResourceContentHash(-667_220_354)
public val Res.string.ONBOARDING_SIGN_IN_BUTTON: StringResource by lazy {
      StringResource("string:ONBOARDING_SIGN_IN_BUTTON", "ONBOARDING_SIGN_IN_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13045, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13077, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13489, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11813, 69),
      ))
    }

@delegate:ResourceContentHash(-612_778_821)
public val Res.string.ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON: StringResource by lazy {
      StringResource("string:ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON", "ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13115, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13139, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13551, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11883, 68),
      ))
    }

@delegate:ResourceContentHash(1_321_946_988)
public val Res.string.ONBOARDING_WELCOME_SIGN_IN_BUTTON: StringResource by lazy {
      StringResource("string:ONBOARDING_WELCOME_SIGN_IN_BUTTON", "ONBOARDING_WELCOME_SIGN_IN_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13188, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13204, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13624, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11952, 53),
      ))
    }

@delegate:ResourceContentHash(1_840_608_878)
public val Res.string.ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL: StringResource by lazy {
      StringResource("string:ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL", "ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13242, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13266, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13682, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12006, 79),
      ))
    }

@delegate:ResourceContentHash(1_899_358_290)
public val Res.string.ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT: StringResource by lazy {
      StringResource("string:ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT", "ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13322, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13358, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13778, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12086, 67),
      ))
    }

@delegate:ResourceContentHash(-434_257_612)
public val Res.string.PAYWALL_OTHER_PLANS_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_OTHER_PLANS_BUTTON", "PAYWALL_OTHER_PLANS_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13390, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13426, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13850, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12154, 54),
      ))
    }

@delegate:ResourceContentHash(-430_803_099)
public val Res.string.PAYWALL_PRIVACY_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_PRIVACY_BUTTON", "PAYWALL_PRIVACY_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13453, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13485, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13913, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12209, 42),
      ))
    }

@delegate:ResourceContentHash(-2_009_504_988)
public val Res.string.PAYWALL_RESTORE_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_RESTORE_BUTTON", "PAYWALL_RESTORE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13500, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13532, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13968, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12252, 54),
      ))
    }

@delegate:ResourceContentHash(442_198_980)
public val Res.string.PAYWALL_SIGN_IN_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_SIGN_IN_BUTTON", "PAYWALL_SIGN_IN_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13559, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13587, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14023, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12307, 38),
      ))
    }

@delegate:ResourceContentHash(1_355_438_298)
public val Res.string.PAYWALL_TERMS_BUTTON: StringResource by lazy {
      StringResource("string:PAYWALL_TERMS_BUTTON", "PAYWALL_TERMS_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13602, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13638, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14070, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12346, 36),
      ))
    }

@delegate:ResourceContentHash(-1_443_397_717)
public val Res.string.PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT: StringResource by lazy {
      StringResource("string:PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT", "PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13647, 203),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13679, 183),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14131, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12383, 167),
      ))
    }

@delegate:ResourceContentHash(-1_391_972_132)
public val Res.string.PCOS_TODAY_LOG_SYMPTOMS_LABEL: StringResource by lazy {
      StringResource("string:PCOS_TODAY_LOG_SYMPTOMS_LABEL", "PCOS_TODAY_LOG_SYMPTOMS_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13851, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13863, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14335, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12551, 53),
      ))
    }

@delegate:ResourceContentHash(-1_957_927_347)
public val Res.string.PERIOD_TRACKER_DAY_FORMAT: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_DAY_FORMAT", "PERIOD_TRACKER_DAY_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13921, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13929, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14409, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12605, 45),
      ))
    }

@delegate:ResourceContentHash(817_180_637)
public val Res.string.PERIOD_TRACKER_LOG_BUTTON_DEFAULT: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_LOG_BUTTON_DEFAULT", "PERIOD_TRACKER_LOG_BUTTON_DEFAULT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13967, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13975, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14455, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12651, 57),
      ))
    }

@delegate:ResourceContentHash(-153_622_806)
public val Res.string.PERIOD_TRACKER_LOG_BUTTON_UNDEFINED: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_LOG_BUTTON_UNDEFINED", "PERIOD_TRACKER_LOG_BUTTON_UNDEFINED", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14037, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14045, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14533, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12709, 55),
      ))
    }

@delegate:ResourceContentHash(906_819_632)
public val Res.string.PERIOD_TRACKER_LOG_FIRST_DAY_MESSAGE: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_LOG_FIRST_DAY_MESSAGE", "PERIOD_TRACKER_LOG_FIRST_DAY_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14101, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14109, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14597, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12765, 108),
      ))
    }

@delegate:ResourceContentHash(-864_271_601)
public val Res.string.PERIOD_TRACKER_PERIOD_LATE_FORMAT: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_PERIOD_LATE_FORMAT", "PERIOD_TRACKER_PERIOD_LATE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14226, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14242, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14738, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12874, 81),
      ))
    }

@delegate:ResourceContentHash(-1_304_499_306)
public val Res.string.PERIOD_TRACKER_PERIOD_LATE_PLURAL_FORMAT: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_PERIOD_LATE_PLURAL_FORMAT", "PERIOD_TRACKER_PERIOD_LATE_PLURAL_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14320, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14336, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14828, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12956, 88),
      ))
    }

@delegate:ResourceContentHash(1_179_383_487)
public val Res.string.PERIOD_TRACKER_PERIOD_PREDICTED_FORMAT: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_PERIOD_PREDICTED_FORMAT", "PERIOD_TRACKER_PERIOD_PREDICTED_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14421, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14437, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14929, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13045, 90),
      ))
    }

@delegate:ResourceContentHash(1_297_519_597)
public val Res.string.PERIOD_TRACKER_PERIOD_PREDICTED_PLURAL_FORMAT: StringResource by lazy {
      StringResource("string:PERIOD_TRACKER_PERIOD_PREDICTED_PLURAL_FORMAT", "PERIOD_TRACKER_PERIOD_PREDICTED_PLURAL_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14528, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14540, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15036, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13136, 97),
      ))
    }

@delegate:ResourceContentHash(-857_941_281)
public val Res.string.PILATES_TODAY_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:PILATES_TODAY_SCREEN_TITLE", "PILATES_TODAY_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14646, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14654, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15150, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13234, 46),
      ))
    }

@delegate:ResourceContentHash(916_407_406)
public val Res.string.PILATES_TODAY_WORKOUTS_SECTION: StringResource by lazy {
      StringResource("string:PILATES_TODAY_WORKOUTS_SECTION", "PILATES_TODAY_WORKOUTS_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14693, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14709, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15205, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13281, 50),
      ))
    }

@delegate:ResourceContentHash(17_519_830)
public val Res.string.RATE_US_ALERT_MESSAGE: StringResource by lazy {
      StringResource("string:RATE_US_ALERT_MESSAGE", "RATE_US_ALERT_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14756, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14768, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15264, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13332, 133),
      ))
    }

@delegate:ResourceContentHash(-1_414_477_780)
public val Res.string.RATE_US_ALERT_NEGATIVE_BUTTON: StringResource by lazy {
      StringResource("string:RATE_US_ALERT_NEGATIVE_BUTTON", "RATE_US_ALERT_NEGATIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14902, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14918, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15398, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13466, 49),
      ))
    }

@delegate:ResourceContentHash(2_109_031_265)
public val Res.string.RATE_US_ALERT_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:RATE_US_ALERT_POSITIVE_BUTTON", "RATE_US_ALERT_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14956, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14968, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15452, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13516, 41),
      ))
    }

@delegate:ResourceContentHash(1_478_310_311)
public val Res.string.RATE_US_ALERT_TITLE_FORMAT: StringResource by lazy {
      StringResource("string:RATE_US_ALERT_TITLE_FORMAT", "RATE_US_ALERT_TITLE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14998, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15010, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15494, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13558, 58),
      ))
    }

@delegate:ResourceContentHash(-1_382_461_745)
public val Res.string.RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON: StringResource by lazy {
      StringResource("string:RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON", "RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15053, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15065, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15549, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13617, 49),
      ))
    }

@delegate:ResourceContentHash(2_109_031_265)
public val Res.string.RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON", "RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15107, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15115, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15599, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13667, 49),
      ))
    }

@delegate:ResourceContentHash(-778_184_641)
public val Res.string.RATE_US_IMPROVE_ALERT_TITLE: StringResource by lazy {
      StringResource("string:RATE_US_IMPROVE_ALERT_TITLE", "RATE_US_IMPROVE_ALERT_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15157, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15165, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15649, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13717, 95),
      ))
    }

@delegate:ResourceContentHash(-1_876_738_120)
public val Res.string.SETTINGS_ABOUT_PRODUCT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_ABOUT_PRODUCT_LABEL", "SETTINGS_ABOUT_PRODUCT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15269, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15245, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15773, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13813, 44),
      ))
    }

@delegate:ResourceContentHash(-919_120_266)
public val Res.string.SETTINGS_CONTACT_US_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_CONTACT_US_LABEL", "SETTINGS_CONTACT_US_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15314, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15294, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15822, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13858, 49),
      ))
    }

@delegate:ResourceContentHash(2_121_100_297)
public val Res.string.SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE", "SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15376, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15344, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15876, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13908, 121),
      ))
    }

@delegate:ResourceContentHash(1_790_519_803)
public val Res.string.SETTINGS_DELETE_ACCOUNT_ALERT_TITLE: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_ALERT_TITLE", "SETTINGS_DELETE_ACCOUNT_ALERT_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15534, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15474, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16022, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14030, 91),
      ))
    }

@delegate:ResourceContentHash(926_976_890)
public val Res.string.SETTINGS_DELETE_ACCOUNT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_LABEL", "SETTINGS_DELETE_ACCOUNT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15646, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15574, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16118, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14122, 73),
      ))
    }

@delegate:ResourceContentHash(-1_684_385_530)
public val Res.string.SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON", "SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15724, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15660, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16204, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14196, 55),
      ))
    }

@delegate:ResourceContentHash(-644_562_671)
public val Res.string.SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON", "SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15784, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15720, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16264, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14252, 75),
      ))
    }

@delegate:ResourceContentHash(868_349_927)
public val Res.string.SETTINGS_GENERAL_SECTION: StringResource by lazy {
      StringResource("string:SETTINGS_GENERAL_SECTION", "SETTINGS_GENERAL_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15864, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15808, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16344, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14328, 44),
      ))
    }

@delegate:ResourceContentHash(-1_633_703_834)
public val Res.string.SETTINGS_LEGAL_PRODUCT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_LEGAL_PRODUCT_LABEL", "SETTINGS_LEGAL_PRODUCT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15909, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15853, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16389, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14373, 44),
      ))
    }

@delegate:ResourceContentHash(-1_646_033_701)
public val Res.string.SETTINGS_LOGOUT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_LOGOUT_LABEL", "SETTINGS_LOGOUT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15962, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15898, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16434, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14418, 37),
      ))
    }

@delegate:ResourceContentHash(-227_153_204)
public val Res.string.SETTINGS_MANAGE_SUBSCRIPTION_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_MANAGE_SUBSCRIPTION_LABEL", "SETTINGS_MANAGE_SUBSCRIPTION_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16004, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15948, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16484, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14456, 70),
      ))
    }

@delegate:ResourceContentHash(1_143_149_115)
public val Res.string.SETTINGS_MEAL_PLAN_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_MEAL_PLAN_LABEL", "SETTINGS_MEAL_PLAN_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16075, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16023, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16555, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14527, 44),
      ))
    }

@delegate:ResourceContentHash(108_352_794)
public val Res.string.SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION: StringResource by lazy {
      StringResource("string:SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION", "SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16124, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16076, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16608, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14572, 57),
      ))
    }

@delegate:ResourceContentHash(1_521_283_486)
public val Res.string.SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION: StringResource by lazy {
      StringResource("string:SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION", "SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16182, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16134, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16666, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14630, 68),
      ))
    }

@delegate:ResourceContentHash(-1_363_397_814)
public val Res.string.SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE", "SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16255, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16207, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16739, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14699, 76),
      ))
    }

@delegate:ResourceContentHash(977_529_678)
public val Res.string.SETTINGS_METRICS_SYSTEM_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_METRICS_SYSTEM_LABEL", "SETTINGS_METRICS_SYSTEM_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16332, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16288, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16820, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14776, 57),
      ))
    }

@delegate:ResourceContentHash(257_028_932)
public val Res.string.SETTINGS_PERIOD_TRACKER_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PERIOD_TRACKER_LABEL", "SETTINGS_PERIOD_TRACKER_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16390, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16350, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16882, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14834, 57),
      ))
    }

@delegate:ResourceContentHash(1_671_325_192)
public val Res.string.SETTINGS_PROFILE_AGE_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_AGE_LABEL", "SETTINGS_PROFILE_AGE_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16448, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16420, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16944, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14892, 38),
      ))
    }

@delegate:ResourceContentHash(-378_224_604)
public val Res.string.SETTINGS_PROFILE_HEIGHT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_HEIGHT_LABEL", "SETTINGS_PROFILE_HEIGHT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16491, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16463, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16987, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14931, 45),
      ))
    }

@delegate:ResourceContentHash(1_929_799_358)
public val Res.string.SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL", "SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16541, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16509, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17033, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14977, 65),
      ))
    }

@delegate:ResourceContentHash(-1_053_938_601)
public val Res.string.SETTINGS_PROFILE_NAME_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_NAME_LABEL", "SETTINGS_PROFILE_NAME_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16607, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16571, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17099, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15043, 43),
      ))
    }

@delegate:ResourceContentHash(-1_257_662_451)
public val Res.string.SETTINGS_PROFILE_SECTION: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_SECTION", "SETTINGS_PROFILE_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16651, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16615, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17139, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15087, 44),
      ))
    }

@delegate:ResourceContentHash(737_201_588)
public val Res.string.SETTINGS_PROFILE_TARGET_WEIGHT_LABEL: StringResource by lazy {
      StringResource("string:SETTINGS_PROFILE_TARGET_WEIGHT_LABEL", "SETTINGS_PROFILE_TARGET_WEIGHT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16692, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16656, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17180, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15132, 64),
      ))
    }

@delegate:ResourceContentHash(676_730_041)
public val Res.string.SETTINGS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:SETTINGS_SCREEN_TITLE", "SETTINGS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16753, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16721, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17241, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15197, 41),
      ))
    }

@delegate:ResourceContentHash(1_278_090_331)
public val Res.string.SHOPPING_LIST_CATEGORY_ALL_LABEL: StringResource by lazy {
      StringResource("string:SHOPPING_LIST_CATEGORY_ALL_LABEL", "SHOPPING_LIST_CATEGORY_ALL_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16803, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16771, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17287, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15239, 44),
      ))
    }

@delegate:ResourceContentHash(631_861_769)
public val Res.string.SHOPPING_LIST_CHECKED_SECTION: StringResource by lazy {
      StringResource("string:SHOPPING_LIST_CHECKED_SECTION", "SHOPPING_LIST_CHECKED_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16852, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16820, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17336, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15284, 45),
      ))
    }

@delegate:ResourceContentHash(1_679_605_207)
public val Res.string.SHOPPING_LIST_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:SHOPPING_LIST_SCREEN_TITLE", "SHOPPING_LIST_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16902, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16866, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17386, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15330, 54),
      ))
    }

@delegate:ResourceContentHash(-708_335_561)
public val Res.string.SHOPPING_LIST_UNCHECKED_SECTION: StringResource by lazy {
      StringResource("string:SHOPPING_LIST_UNCHECKED_SECTION", "SHOPPING_LIST_UNCHECKED_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16957, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16925, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17445, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15385, 47),
      ))
    }

@delegate:ResourceContentHash(358_438_978)
public val Res.string.TODAY_ACTIVITY_LABEL: StringResource by lazy {
      StringResource("string:TODAY_ACTIVITY_LABEL", "TODAY_ACTIVITY_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17009, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16981, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17501, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15433, 40),
      ))
    }

@delegate:ResourceContentHash(1_439_622_758)
public val Res.string.TODAY_LOGGED_SYMPTOMS_LABEL: StringResource by lazy {
      StringResource("string:TODAY_LOGGED_SYMPTOMS_LABEL", "TODAY_LOGGED_SYMPTOMS_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17054, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17022, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17542, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15474, 43),
      ))
    }

@delegate:ResourceContentHash(1_339_721_198)
public val Res.string.TODAY_LOG_CONTROLS_SECTION: StringResource by lazy {
      StringResource("string:TODAY_LOG_CONTROLS_SECTION", "TODAY_LOG_CONTROLS_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17110, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17074, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17594, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15518, 54),
      ))
    }

@delegate:ResourceContentHash(2_107_562_047)
public val Res.string.TODAY_LOG_FOOD_BUTTON: StringResource by lazy {
      StringResource("string:TODAY_LOG_FOOD_BUTTON", "TODAY_LOG_FOOD_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17173, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17133, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17657, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15573, 41),
      ))
    }

@delegate:ResourceContentHash(1_138_601_962)
public val Res.string.TODAY_LOG_SYMPTOMS_LABEL: StringResource by lazy {
      StringResource("string:TODAY_LOG_SYMPTOMS_LABEL", "TODAY_LOG_SYMPTOMS_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17231, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17187, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17723, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15615, 48),
      ))
    }

@delegate:ResourceContentHash(-2_125_504_051)
public val Res.string.TODAY_LOG_WATER_BUTTON: StringResource by lazy {
      StringResource("string:TODAY_LOG_WATER_BUTTON", "TODAY_LOG_WATER_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17296, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17248, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17792, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15664, 42),
      ))
    }

@delegate:ResourceContentHash(-1_396_504_514)
public val Res.string.TODAY_LOG_WEIGHT_BUTTON: StringResource by lazy {
      StringResource("string:TODAY_LOG_WEIGHT_BUTTON", "TODAY_LOG_WEIGHT_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17355, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17299, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17847, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15707, 47),
      ))
    }

@delegate:ResourceContentHash(1_630_494_175)
public val Res.string.TODAY_MEALS_SECTION: StringResource by lazy {
      StringResource("string:TODAY_MEALS_SECTION", "TODAY_MEALS_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17419, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17351, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17907, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15755, 43),
      ))
    }

@delegate:ResourceContentHash(274_484_107)
public val Res.string.TODAY_MEAL_PLAN_SECTION: StringResource by lazy {
      StringResource("string:TODAY_MEAL_PLAN_SECTION", "TODAY_MEAL_PLAN_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17471, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17403, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17955, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15799, 51),
      ))
    }

@delegate:ResourceContentHash(359_299_014)
public val Res.string.TODAY_WATER_INTAKE_LABEL: StringResource by lazy {
      StringResource("string:TODAY_WATER_INTAKE_LABEL", "TODAY_WATER_INTAKE_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17523, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17459, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18011, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15851, 48),
      ))
    }

@delegate:ResourceContentHash(-1_159_753_688)
public val Res.string.TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON: StringResource by lazy {
      StringResource("string:TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON", "TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17572, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17512, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18068, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15900, 53),
      ))
    }

@delegate:ResourceContentHash(2_088_683_876)
public val Res.string.TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL: StringResource by lazy {
      StringResource("string:TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL", "TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17634, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17566, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18122, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15954, 91),
      ))
    }

@delegate:ResourceContentHash(359_299_014)
public val Res.string.TODAY_WATER_INTAKE_SHEET_TITLE: StringResource by lazy {
      StringResource("string:TODAY_WATER_INTAKE_SHEET_TITLE", "TODAY_WATER_INTAKE_SHEET_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17730, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17658, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18234, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16046, 54),
      ))
    }

@delegate:ResourceContentHash(-1_084_134_679)
public val Res.string.TODAY_WEIGHT_LABEL: StringResource by lazy {
      StringResource("string:TODAY_WEIGHT_LABEL", "TODAY_WEIGHT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17785, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17717, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18297, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16101, 34),
      ))
    }

@delegate:ResourceContentHash(803_834_726)
public val Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION: StringResource by lazy {
      StringResource("string:TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION", "TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17824, 327),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17752, 279),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18332, 315),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16136, 259),
      ))
    }

@delegate:ResourceContentHash(1_149_546_927)
public val Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON: StringResource by lazy {
      StringResource("string:TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON", "TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18152, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18032, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18648, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16396, 67),
      ))
    }

@delegate:ResourceContentHash(335_515_460)
public val Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON", "TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18228, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18108, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18712, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16464, 67),
      ))
    }

@delegate:ResourceContentHash(721_891_758)
public val Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_TITLE: StringResource by lazy {
      StringResource("string:TUTORIAL_PERSONAL_MEAL_PLAN_TITLE", "TUTORIAL_PERSONAL_MEAL_PLAN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18312, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18184, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18796, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16532, 81),
      ))
    }

@delegate:ResourceContentHash(1_782_810_894)
public val Res.string.UPDATE_AGE_INFO: StringResource by lazy {
      StringResource("string:UPDATE_AGE_INFO", "UPDATE_AGE_INFO", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18410, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18274, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18890, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16614, 95),
      ))
    }

@delegate:ResourceContentHash(-1_366_325_385)
public val Res.string.UPDATE_AGE_LOW_AGE_ERROR: StringResource by lazy {
      StringResource("string:UPDATE_AGE_LOW_AGE_ERROR", "UPDATE_AGE_LOW_AGE_ERROR", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18530, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18378, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19006, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16710, 68),
      ))
    }

@delegate:ResourceContentHash(-556_317_788)
public val Res.string.UPDATE_AGE_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_AGE_SCREEN_TITLE", "UPDATE_AGE_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18603, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18451, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19087, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16779, 43),
      ))
    }

@delegate:ResourceContentHash(-907_725_017)
public val Res.string.UPDATE_FOOD_PREFERENCES_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_FOOD_PREFERENCES_SCREEN_TITLE", "UPDATE_FOOD_PREFERENCES_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18651, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18495, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19135, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16823, 68),
      ))
    }

@delegate:ResourceContentHash(-813_113_550)
public val Res.string.UPDATE_FOOD_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_FOOD_SCREEN_TITLE", "UPDATE_FOOD_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18732, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18572, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19224, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16892, 44),
      ))
    }

@delegate:ResourceContentHash(-1_500_631_541)
public val Res.string.UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT: StringResource by lazy {
      StringResource("string:UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT", "UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18793, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18625, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19281, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16937, 85),
      ))
    }

@delegate:ResourceContentHash(1_722_639_085)
public val Res.string.UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT: StringResource by lazy {
      StringResource("string:UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT", "UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18891, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18715, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19383, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17023, 84),
      ))
    }

@delegate:ResourceContentHash(713_811_975)
public val Res.string.UPDATE_HEIGHT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_HEIGHT_SCREEN_TITLE", "UPDATE_HEIGHT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18984, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18804, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19484, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17108, 50),
      ))
    }

@delegate:ResourceContentHash(-2_023_604_917)
public val Res.string.UPDATE_INITIAL_WEIGHT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_INITIAL_WEIGHT_SCREEN_TITLE", "UPDATE_INITIAL_WEIGHT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19039, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18851, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19535, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17159, 70),
      ))
    }

@delegate:ResourceContentHash(-195_462_778)
public val Res.string.UPDATE_NAME_INFO: StringResource by lazy {
      StringResource("string:UPDATE_NAME_INFO", "UPDATE_NAME_INFO", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19110, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18914, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19606, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17230, 76),
      ))
    }

@delegate:ResourceContentHash(-1_398_845_473)
public val Res.string.UPDATE_NAME_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_NAME_SCREEN_TITLE", "UPDATE_NAME_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19195, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18995, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19703, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17307, 44),
      ))
    }

@delegate:ResourceContentHash(-400_915_889)
public val Res.string.UPDATE_TARGET_WEIGHT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_TARGET_WEIGHT_SCREEN_TITLE", "UPDATE_TARGET_WEIGHT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19240, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19040, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19748, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17352, 65),
      ))
    }

@delegate:ResourceContentHash(-341_299_630)
public val Res.string.UPDATE_WEIGHT_INFO_LABEL: StringResource by lazy {
      StringResource("string:UPDATE_WEIGHT_INFO_LABEL", "UPDATE_WEIGHT_INFO_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19306, 180),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19106, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19814, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17418, 120),
      ))
    }

@delegate:ResourceContentHash(417_801_622)
public val Res.string.UPDATE_WEIGHT_LOG_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_WEIGHT_LOG_SCREEN_TITLE", "UPDATE_WEIGHT_LOG_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19487, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19247, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19967, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17539, 62),
      ))
    }

@delegate:ResourceContentHash(417_801_622)
public val Res.string.UPDATE_WEIGHT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_WEIGHT_SCREEN_TITLE", "UPDATE_WEIGHT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19562, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19310, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20042, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17602, 58),
      ))
    }

@delegate:ResourceContentHash(-1_091_732_948)
public val Res.string.USER_AVATAR_DELETE_CONFIRMATION_MESSAGE: StringResource by lazy {
      StringResource("string:USER_AVATAR_DELETE_CONFIRMATION_MESSAGE", "USER_AVATAR_DELETE_CONFIRMATION_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19633, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19369, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20113, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17661, 87),
      ))
    }

@delegate:ResourceContentHash(1_508_685_540)
public val Res.string.USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON", "USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19749, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19461, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20213, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17749, 63),
      ))
    }

@delegate:ResourceContentHash(432_633_088)
public val Res.string.USER_AVATAR_DELETE_CONFIRMATION_TITLE: StringResource by lazy {
      StringResource("string:USER_AVATAR_DELETE_CONFIRMATION_TITLE", "USER_AVATAR_DELETE_CONFIRMATION_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19817, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19529, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20281, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17813, 65),
      ))
    }

@delegate:ResourceContentHash(818_727_618)
public val Res.string.USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON", "USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19883, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19595, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20351, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17879, 62),
      ))
    }

@delegate:ResourceContentHash(-774_193_583)
public val Res.string.USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON", "USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19954, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19662, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20422, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17942, 66),
      ))
    }

@delegate:ResourceContentHash(-284_568_502)
public val Res.string.USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON", "USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20025, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19733, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20493, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18009, 75),
      ))
    }

@delegate:ResourceContentHash(-48_897_848)
public val Res.string.USER_AVATAR_IMAGE_PICKER_TITLE: StringResource by lazy {
      StringResource("string:USER_AVATAR_IMAGE_PICKER_TITLE", "USER_AVATAR_IMAGE_PICKER_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20105, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19809, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20573, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18085, 62),
      ))
    }

@delegate:ResourceContentHash(279_095_314)
public val Res.string.USER_AVATAR_PERMISSION_REQUIRED_MESSAGE: StringResource by lazy {
      StringResource("string:USER_AVATAR_PERMISSION_REQUIRED_MESSAGE", "USER_AVATAR_PERMISSION_REQUIRED_MESSAGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20180, 243),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19876, 227),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20648, 235),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18148, 195),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("ME_WEIGHT_LOSS_PROGRESS_SECTION", Res.string.ME_WEIGHT_LOSS_PROGRESS_SECTION)
  map.put("ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT", Res.string.ME_WEIGHT_LOSS_PROGRESS_VALUE_FORMAT)
  map.put("ONBOARDING_SIGN_IN_BUTTON", Res.string.ONBOARDING_SIGN_IN_BUTTON)
  map.put("ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON", Res.string.ONBOARDING_WELCOME_NO_ACCOUNT_BUTTON)
  map.put("ONBOARDING_WELCOME_SIGN_IN_BUTTON", Res.string.ONBOARDING_WELCOME_SIGN_IN_BUTTON)
  map.put("ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL", Res.string.ONBOARDING_WELLNESS_PROFILE_BMI_GRAPH_LABEL)
  map.put("ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT", Res.string.ONBOARDING_WELLNESS_PROFILE_YOUR_BMI_FORMAT)
  map.put("PAYWALL_OTHER_PLANS_BUTTON", Res.string.PAYWALL_OTHER_PLANS_BUTTON)
  map.put("PAYWALL_PRIVACY_BUTTON", Res.string.PAYWALL_PRIVACY_BUTTON)
  map.put("PAYWALL_RESTORE_BUTTON", Res.string.PAYWALL_RESTORE_BUTTON)
  map.put("PAYWALL_SIGN_IN_BUTTON", Res.string.PAYWALL_SIGN_IN_BUTTON)
  map.put("PAYWALL_TERMS_BUTTON", Res.string.PAYWALL_TERMS_BUTTON)
  map.put("PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT", Res.string.PCOS_TODAY_HEALTH_ADVICE_EMPTY_TEXT)
  map.put("PCOS_TODAY_LOG_SYMPTOMS_LABEL", Res.string.PCOS_TODAY_LOG_SYMPTOMS_LABEL)
  map.put("PERIOD_TRACKER_DAY_FORMAT", Res.string.PERIOD_TRACKER_DAY_FORMAT)
  map.put("PERIOD_TRACKER_LOG_BUTTON_DEFAULT", Res.string.PERIOD_TRACKER_LOG_BUTTON_DEFAULT)
  map.put("PERIOD_TRACKER_LOG_BUTTON_UNDEFINED", Res.string.PERIOD_TRACKER_LOG_BUTTON_UNDEFINED)
  map.put("PERIOD_TRACKER_LOG_FIRST_DAY_MESSAGE", Res.string.PERIOD_TRACKER_LOG_FIRST_DAY_MESSAGE)
  map.put("PERIOD_TRACKER_PERIOD_LATE_FORMAT", Res.string.PERIOD_TRACKER_PERIOD_LATE_FORMAT)
  map.put("PERIOD_TRACKER_PERIOD_LATE_PLURAL_FORMAT", Res.string.PERIOD_TRACKER_PERIOD_LATE_PLURAL_FORMAT)
  map.put("PERIOD_TRACKER_PERIOD_PREDICTED_FORMAT", Res.string.PERIOD_TRACKER_PERIOD_PREDICTED_FORMAT)
  map.put("PERIOD_TRACKER_PERIOD_PREDICTED_PLURAL_FORMAT", Res.string.PERIOD_TRACKER_PERIOD_PREDICTED_PLURAL_FORMAT)
  map.put("PILATES_TODAY_SCREEN_TITLE", Res.string.PILATES_TODAY_SCREEN_TITLE)
  map.put("PILATES_TODAY_WORKOUTS_SECTION", Res.string.PILATES_TODAY_WORKOUTS_SECTION)
  map.put("RATE_US_ALERT_MESSAGE", Res.string.RATE_US_ALERT_MESSAGE)
  map.put("RATE_US_ALERT_NEGATIVE_BUTTON", Res.string.RATE_US_ALERT_NEGATIVE_BUTTON)
  map.put("RATE_US_ALERT_POSITIVE_BUTTON", Res.string.RATE_US_ALERT_POSITIVE_BUTTON)
  map.put("RATE_US_ALERT_TITLE_FORMAT", Res.string.RATE_US_ALERT_TITLE_FORMAT)
  map.put("RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON", Res.string.RATE_US_IMPROVE_ALERT_NEGATIVE_BUTTON)
  map.put("RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON", Res.string.RATE_US_IMPROVE_ALERT_POSITIVE_BUTTON)
  map.put("RATE_US_IMPROVE_ALERT_TITLE", Res.string.RATE_US_IMPROVE_ALERT_TITLE)
  map.put("SETTINGS_ABOUT_PRODUCT_LABEL", Res.string.SETTINGS_ABOUT_PRODUCT_LABEL)
  map.put("SETTINGS_CONTACT_US_LABEL", Res.string.SETTINGS_CONTACT_US_LABEL)
  map.put("SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE", Res.string.SETTINGS_DELETE_ACCOUNT_ALERT_MESSAGE)
  map.put("SETTINGS_DELETE_ACCOUNT_ALERT_TITLE", Res.string.SETTINGS_DELETE_ACCOUNT_ALERT_TITLE)
  map.put("SETTINGS_DELETE_ACCOUNT_LABEL", Res.string.SETTINGS_DELETE_ACCOUNT_LABEL)
  map.put("SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON", Res.string.SETTINGS_DELETE_ACCOUNT_NEGATIVE_BUTTON)
  map.put("SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON", Res.string.SETTINGS_DELETE_ACCOUNT_POSITIVE_BUTTON)
  map.put("SETTINGS_GENERAL_SECTION", Res.string.SETTINGS_GENERAL_SECTION)
  map.put("SETTINGS_LEGAL_PRODUCT_LABEL", Res.string.SETTINGS_LEGAL_PRODUCT_LABEL)
  map.put("SETTINGS_LOGOUT_LABEL", Res.string.SETTINGS_LOGOUT_LABEL)
  map.put("SETTINGS_MANAGE_SUBSCRIPTION_LABEL", Res.string.SETTINGS_MANAGE_SUBSCRIPTION_LABEL)
  map.put("SETTINGS_MEAL_PLAN_LABEL", Res.string.SETTINGS_MEAL_PLAN_LABEL)
  map.put("SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION", Res.string.SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION)
  map.put("SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION", Res.string.SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION)
  map.put("SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE", Res.string.SETTINGS_MEAL_PLAN_SETTINGS_SCREEN_TITLE)
  map.put("SETTINGS_METRICS_SYSTEM_LABEL", Res.string.SETTINGS_METRICS_SYSTEM_LABEL)
  map.put("SETTINGS_PERIOD_TRACKER_LABEL", Res.string.SETTINGS_PERIOD_TRACKER_LABEL)
  map.put("SETTINGS_PROFILE_AGE_LABEL", Res.string.SETTINGS_PROFILE_AGE_LABEL)
  map.put("SETTINGS_PROFILE_HEIGHT_LABEL", Res.string.SETTINGS_PROFILE_HEIGHT_LABEL)
  map.put("SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL", Res.string.SETTINGS_PROFILE_INITIAL_WEIGHT_LABEL)
  map.put("SETTINGS_PROFILE_NAME_LABEL", Res.string.SETTINGS_PROFILE_NAME_LABEL)
  map.put("SETTINGS_PROFILE_SECTION", Res.string.SETTINGS_PROFILE_SECTION)
  map.put("SETTINGS_PROFILE_TARGET_WEIGHT_LABEL", Res.string.SETTINGS_PROFILE_TARGET_WEIGHT_LABEL)
  map.put("SETTINGS_SCREEN_TITLE", Res.string.SETTINGS_SCREEN_TITLE)
  map.put("SHOPPING_LIST_CATEGORY_ALL_LABEL", Res.string.SHOPPING_LIST_CATEGORY_ALL_LABEL)
  map.put("SHOPPING_LIST_CHECKED_SECTION", Res.string.SHOPPING_LIST_CHECKED_SECTION)
  map.put("SHOPPING_LIST_SCREEN_TITLE", Res.string.SHOPPING_LIST_SCREEN_TITLE)
  map.put("SHOPPING_LIST_UNCHECKED_SECTION", Res.string.SHOPPING_LIST_UNCHECKED_SECTION)
  map.put("TODAY_ACTIVITY_LABEL", Res.string.TODAY_ACTIVITY_LABEL)
  map.put("TODAY_LOGGED_SYMPTOMS_LABEL", Res.string.TODAY_LOGGED_SYMPTOMS_LABEL)
  map.put("TODAY_LOG_CONTROLS_SECTION", Res.string.TODAY_LOG_CONTROLS_SECTION)
  map.put("TODAY_LOG_FOOD_BUTTON", Res.string.TODAY_LOG_FOOD_BUTTON)
  map.put("TODAY_LOG_SYMPTOMS_LABEL", Res.string.TODAY_LOG_SYMPTOMS_LABEL)
  map.put("TODAY_LOG_WATER_BUTTON", Res.string.TODAY_LOG_WATER_BUTTON)
  map.put("TODAY_LOG_WEIGHT_BUTTON", Res.string.TODAY_LOG_WEIGHT_BUTTON)
  map.put("TODAY_MEALS_SECTION", Res.string.TODAY_MEALS_SECTION)
  map.put("TODAY_MEAL_PLAN_SECTION", Res.string.TODAY_MEAL_PLAN_SECTION)
  map.put("TODAY_WATER_INTAKE_LABEL", Res.string.TODAY_WATER_INTAKE_LABEL)
  map.put("TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON", Res.string.TODAY_WATER_INTAKE_SHEET_CLOSE_BUTTON)
  map.put("TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL", Res.string.TODAY_WATER_INTAKE_SHEET_DAILY_AMOUNT_LABEL)
  map.put("TODAY_WATER_INTAKE_SHEET_TITLE", Res.string.TODAY_WATER_INTAKE_SHEET_TITLE)
  map.put("TODAY_WEIGHT_LABEL", Res.string.TODAY_WEIGHT_LABEL)
  map.put("TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION", Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_DESCRIPTION)
  map.put("TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON", Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_NEGATIVE_BUTTON)
  map.put("TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON", Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_POSITIVE_BUTTON)
  map.put("TUTORIAL_PERSONAL_MEAL_PLAN_TITLE", Res.string.TUTORIAL_PERSONAL_MEAL_PLAN_TITLE)
  map.put("UPDATE_AGE_INFO", Res.string.UPDATE_AGE_INFO)
  map.put("UPDATE_AGE_LOW_AGE_ERROR", Res.string.UPDATE_AGE_LOW_AGE_ERROR)
  map.put("UPDATE_AGE_SCREEN_TITLE", Res.string.UPDATE_AGE_SCREEN_TITLE)
  map.put("UPDATE_FOOD_PREFERENCES_SCREEN_TITLE", Res.string.UPDATE_FOOD_PREFERENCES_SCREEN_TITLE)
  map.put("UPDATE_FOOD_SCREEN_TITLE", Res.string.UPDATE_FOOD_SCREEN_TITLE)
  map.put("UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT", Res.string.UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT)
  map.put("UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT", Res.string.UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT)
  map.put("UPDATE_HEIGHT_SCREEN_TITLE", Res.string.UPDATE_HEIGHT_SCREEN_TITLE)
  map.put("UPDATE_INITIAL_WEIGHT_SCREEN_TITLE", Res.string.UPDATE_INITIAL_WEIGHT_SCREEN_TITLE)
  map.put("UPDATE_NAME_INFO", Res.string.UPDATE_NAME_INFO)
  map.put("UPDATE_NAME_SCREEN_TITLE", Res.string.UPDATE_NAME_SCREEN_TITLE)
  map.put("UPDATE_TARGET_WEIGHT_SCREEN_TITLE", Res.string.UPDATE_TARGET_WEIGHT_SCREEN_TITLE)
  map.put("UPDATE_WEIGHT_INFO_LABEL", Res.string.UPDATE_WEIGHT_INFO_LABEL)
  map.put("UPDATE_WEIGHT_LOG_SCREEN_TITLE", Res.string.UPDATE_WEIGHT_LOG_SCREEN_TITLE)
  map.put("UPDATE_WEIGHT_SCREEN_TITLE", Res.string.UPDATE_WEIGHT_SCREEN_TITLE)
  map.put("USER_AVATAR_DELETE_CONFIRMATION_MESSAGE", Res.string.USER_AVATAR_DELETE_CONFIRMATION_MESSAGE)
  map.put("USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON", Res.string.USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON)
  map.put("USER_AVATAR_DELETE_CONFIRMATION_TITLE", Res.string.USER_AVATAR_DELETE_CONFIRMATION_TITLE)
  map.put("USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON", Res.string.USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON)
  map.put("USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON", Res.string.USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON)
  map.put("USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON", Res.string.USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON)
  map.put("USER_AVATAR_IMAGE_PICKER_TITLE", Res.string.USER_AVATAR_IMAGE_PICKER_TITLE)
  map.put("USER_AVATAR_PERMISSION_REQUIRED_MESSAGE", Res.string.USER_AVATAR_PERMISSION_REQUIRED_MESSAGE)
}
